import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import Pagination from "../common/pagination";
import SglContext from "../SglContext";
import { Link } from "react-router-dom";
import './classes.css';
export default function Classes(props) {
  const [showName, setShowName] = useState("");

  const [page, setPage] = useState(1);
  const [search_text, setsearch_text] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [sort, setSort] = useState({ sort_on: "number", sort_type: "asc" });
  const [totalRows, setTotalRows] = useState(0);
  const [paginationElement, setPaginationElement] = useState(null);
  const [classes, setClasses] = useState([]);
  const [currentShow, setCurrentShow] = useState(
    localStorage.getItem("show_id")
  );
  const [loading, setLoading] = useState(true);
  const Sgl = useContext(SglContext);

  useEffect(() => {
    // setCurrentShow(props.currentShow);
    setCurrentShow(localStorage.getItem("show_id"));
  }, [props.currentShow]); // add props as dependencies

  useEffect(() => {
    setPaginationElement(React.createRef());
  }, []);

  useEffect(() => {
    axios
      .get(Sgl.nestApiUrl + "/classes", {
        params: {
          sort_on: sort.sort_on,
          sort_type: sort.sort_type,
          page: page,
          search_text: search_text,
          show_id: currentShow,
          customer_id: Sgl.company_id,
        },
      })
      .then((res) => {
        document.title = "Class for " + res.data.show_name;
        Sgl.reportToGA( '/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + currentShow + '/classes/list/page/' + page );
        Sgl.reportToFB( '/sgl-wp-plugin/' + Sgl.company_urlpath + '/' + currentShow + '/classes/list/page/' + page );
        setClasses(res.data.classes);
        setCurrentShow(res.data.show_id);
        setShowName(res.data.show_name);
        setTotalRows(res.data.total_classes);
        setLoading(false);
      });
  }, [sort, page, search_text, currentShow]);

  function onSearch(e) {
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    e.persist();
    setSearchTimeout(
      setTimeout(() => {
        setsearch_text(e.target.value);
        setPage(1);
      }, 700)
    );
  }

  function onSort(column) {
    if (sort.sort_on != column) {
      setSort({ sort_on: column, sort_type: "asc" });
    } else {
      setSort({
        sort_on: column,
        sort_type: sort.sort_type === "desc" ? "asc" : "desc",
      });
    }
    setPage(1);
  }

  function setArrow(column) {
    let className = "direction";
    if (sort.sort_on === column) {
      className += sort.sort_type === "asc" ? " asc" : " desc";
    }
    return className;
  }

  function onChangePage(page) {
    setPage(page);
  }

  if (loading) {
    return null;
  }

  return (
    <div className="section-to-print">
      <section className='search-area'>
        <table with='100%'>
          <tbody>
            <tr>
              <td>
                <h2 className='sgl-h2'>Classes for {showName}</h2>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type='text'
                  className='input'
                  placeholder='Enter Class Number / Name to search.'
                  onKeyUp={(e) => onSearch(e)}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
      <br />
      <div className='div-responsive classescss'>
        <table className='table table-striped table-hover table-responsive'>
          <tbody>
            <tr className='sgl-primary-header'>
              <th className='center-align' onClick={() => onSort("number")}>
                Number <span className={setArrow("number")}></span>
              </th>
              <th style={{ minWidth: "30px" }} onClick={() => onSort("name")}>
                Name <span className={setArrow("name")}></span>
              </th>
              <th
                className='center-align'
                style={{ minWidth: "30px" }}
                onClick={() => onSort("entry_count")}>
                Entries <span className={setArrow("entry_count")}></span>
              </th>
            </tr>
            {classes.map((data, index) => {
              const strikeout = data.cancelled == true ? " strikeout" : "";
              return (
                <tr key={data.class_id} className={strikeout + " sgl-anchor"}>
                  <td className='center-align'>
                    <Link
                      to={
                        "/classes/detail?cid=" +
                        data.class_id +
                        "&sid=" +
                        currentShow
                      }>
                      {data.number}
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={
                        "/classes/detail?cid=" +
                        data.class_id +
                        "&sid=" +
                        currentShow
                      }>
                      {data.name}
                      {data.sponsor ? (
                        <span className='sponsor_text'>
                          {" "}
                          (Sponsored By: {data.sponsor})
                        </span>
                      ) : (
                        ""
                      )}
                      {/* &nbsp;
                    {checkIsLive(data.class_id) ? (
                      <span class='live_class_badge'>Live</span>
                    ) : (
                      ""
                    )}
                    {data.cancelled == true ? " - CANCELLED " : ""} */}
                    </Link>
                  </td>
                  <td className='center-align'>
                    <Link
                      to={
                        "/classes/detail?cid=" +
                        data.class_id +
                        "&sid=" +
                        currentShow
                      }>
                      {data.entry_count}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Pagination
        items={totalRows}
        onChangePage={onChangePage}
        initialPage={page}
        ref={paginationElement}
      />
      <div>
        <span className='link_color'>
          <b>
            Showing {(page - 1) * 10 + 1} to {(page - 1) * 10 + classes.length}{" "}
            of {totalRows} results.
          </b>
        </span>
      </div>
      <div className='copyright-text'>
        {process.env.REACT_APP_COPYRIGHT_TEXT}
      </div>
    </div>
  );
}
